import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "jumpto-container" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}

import { onMounted, ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import Loader from "@/components/Loader.vue";
import Page from "@/components/v2/layout/Page.vue";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import Header from "@/components/v2/certifications/Header.vue";
import FlyoutMenu from "@/components/v2/shared/FlyoutMenu.vue";
import CertificationsAndDisbursements from "@/components/v2/certifications/CertificationsAndDisbursements.vue";
import { CertificationVM } from "@/types/certifications";
import { JumpToMenuLink } from "@/types/jumpto-menu";
import { useCertification } from "@/composables/certification/useCertification";
import { DisbursementVM, DisbursementAddedEvent } from "@/types/disbursements";
import { $api } from "@/services/api1";
import functions from "@/use/functions.js";


export default /*@__PURE__*/_defineComponent({
  __name: 'Certification',
  setup(__props) {

const route = useRoute();

const certificationId = ref<number>();

const isLoading = ref<boolean>(true);

const movedToLoanService = computed<boolean>(
  () => certification.value?.appMovedToLoanSvc || false
);

const certification = ref<CertificationVM>();

const links = computed<Array<JumpToMenuLink>>(
  () => certification.value?.jumpToMenuLinks || []
);

const menuLinks = computed(() => links.value.filter((l: any) => l.visible));

const { getCertification } = useCertification();

function setCertificationId() {
  const id = route.params.id;
  certificationId.value = Number(id);
}

function setCertification(certificationVM: CertificationVM) {
  certification.value = certificationVM;
}

async function handleCommentAdded() {
  if (certification.value) {
    const commentData = await $api.certifications.getComments({
      certificationId: certification.value.form.id,
      appId: certification.value.appId,
      loanId: certification.value.loanId,
    });

    certification.value.comments = commentData;
  }
}

async function handleCertificationUpdated(
  updatedCertification: CertificationVM
) {
  await initialize("certificationUpdated");
  functions.closeModal();
}

async function handleDisbursementUpdated(event: {
  disbursement: DisbursementVM;
  disbursements: DisbursementVM[];
}) {
  if (certification.value) {
    const response = await getCertification(certificationId.value);

    if (response?.success) {
      // if any other disb rows are being edited - leave them in edit mode - do not reset them
      const index = certification.value?.disbursements.findIndex(
        (d: DisbursementVM) => d.details.id === event.disbursement.details.id
      );

      if (index !== -1) {
        certification.value.disbursements[index] = event.disbursement;
      }

      response.results.disbursements = certification.value?.disbursements;

      setCertification(response.results);
    }
  }

  functions.closeModal();
}

async function handleDisbursementAdded(data: DisbursementAddedEvent) {
  if (certification.value) {
    if (data.disbursementIndex !== -1) {
      certification.value.disbursements[data.disbursementIndex] =
        data.disbursement;
    }
  }

  await initialize("disbursementAdded");

  functions.closeModal();
}

async function initialize(listener?: string) {
  setCertificationId();
  const response = await getCertification(certificationId.value);
  if (response?.success) {
    if (listener !== undefined && listener === "disbursementUpdated") {
      response.results.disbursements = certification.value?.disbursements;
    }

    if (listener !== undefined && listener === "disbursementAdded") {
      response.results.disbursements = certification.value?.disbursements;
    }

    if (listener !== undefined && listener === "commentAdded") {
      response.results.disbursements = certification.value?.disbursements;
      response.results.form = certification.value?.form;
      response.results.initialFormValues =
        certification.value?.initialFormValues;
    }

    setCertification(response.results);
  } else {
    functions.openModal({
      title: "Oops!",
      description:
        "There was an issue getting the Certification & Disbursements. Please try again later.",
    });
  }

  isLoading.value = false;
}
onMounted(async () => {
  await initialize();
});

watch(
  () => route.params.id,
  async (newId, oldId) => {
    console.log("certification id", newId);
    certificationId.value = Number(newId);
    if (newId !== oldId) {
      isLoading.value = true;
      await initialize();
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createBlock(Loader, { key: 0 }))
    : (_openBlock(), _createBlock(Page, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(Breadcrumbs, {
            "root-path": "/certifications",
            showJumpTo: true
          }, _createSlots({
            jumpto: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(FlyoutMenu, {
                  title: "Jump To",
                  items: menuLinks.value
                }, null, 8, ["items"])
              ])
            ]),
            _: 2
          }, [
            (movedToLoanService.value)
              ? {
                  name: "loanservice-banner",
                  fn: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon-circle-check loanservice-banner" }, " This application has been completed and moved to Loan Service. ", -1))
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024),
          (certification.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (certification.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(Header, { certification: certification.value }, null, 8, ["certification"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(CertificationsAndDisbursements, {
                  certification: certification.value,
                  onCommentAdded: handleCommentAdded,
                  onCertificationUpdated: _cache[0] || (_cache[0] = ($event: any) => (handleCertificationUpdated($event))),
                  onDisbursementAdded: _cache[1] || (_cache[1] = ($event: any) => (handleDisbursementAdded($event))),
                  onDisbursementUpdated: _cache[2] || (_cache[2] = ($event: any) => (handleDisbursementUpdated($event)))
                }, null, 8, ["certification"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
}
}

})